///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

// Moved this logic to its own file so that it can be mocked for tests since
// test renderers do not calculate element heights and won't assign a value
// to the `scrollTop` property

export const setElementScrollTop = element => {
  element.scrollTop = element.scrollHeight;
  return element;
};

export default setElementScrollTop;
